"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Loading_1 = require("./Loading");
var Loader = function (_a) {
    var children = _a.children, isLoading = _a.isLoading, _b = _a.loaderMarginTop, loaderMarginTop = _b === void 0 ? '60px' : _b, _c = _a.loaderWidth, loaderWidth = _c === void 0 ? '505px' : _c, _d = _a.loaderHeight, loaderHeight = _d === void 0 ? '106px' : _d;
    return isLoading ? ((0, jsx_runtime_1.jsx)(Loading_1.default, { marginTop: loaderMarginTop, width: loaderWidth, height: loaderHeight })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }));
};
exports.default = Loader;
